module.exports = __webpack_public_path__ + "img/donut.60004d79.svg";